import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import Box from 'shopper/components/Box';

import GooglePublisherTagAdSlot from 'components/AdSlots/GooglePublisherTagAdSlot';

import Z_INDEX_SCALE from 'constants/zIndexScale';

const GooglePublisherTagLandscapeAdSlot = ({
  adId,
  adPath,
  adSizes,
  adResponsiveSizesMap,
  height,
  width,
  display,
  showAdSlotOnBreakpoints,
  ...rest
}) => {
  const adSlotRef = useRef(null);
  const [displayStyle, setDisplayStyle] = useState(display);

  useEffect(() => {
    const { willScriptLoad } = adSlotRef.current;

    if (willScriptLoad !== undefined) {
      setDisplayStyle(willScriptLoad ? display ?? 'block' : 'none');
    }
  }, [adSlotRef.current?.willScriptLoad, display]);

  return (
    <Box
      height={height}
      zIndex={Z_INDEX_SCALE.SIZE_1}
      display={displayStyle}
      full
      {...rest}
    >
      <GooglePublisherTagAdSlot
        ref={adSlotRef}
        adId={adId}
        adPath={adPath}
        adSizes={adSizes}
        adResponsiveSizesMap={adResponsiveSizesMap}
        showAdSlotOnBreakpoints={showAdSlotOnBreakpoints}
        height={height}
        width={width || '100%'}
        display="flex"
        justifyContent="center"
      />
    </Box>
  );
};

GooglePublisherTagLandscapeAdSlot.defaultProps = {
  adSizes: [
    [320, 50],
    [728, 90],
  ],
  adResponsiveSizesMap: [
    {
      viewport: [768, 0],
      sizesMap: [728, 90],
    },
    {
      viewport: [0, 0],
      sizesMap: [320, 50],
    },
  ],
  height: [50, null, 90],
  showAdSlotOnBreakpoints: [],
};

GooglePublisherTagLandscapeAdSlot.propTypes = {
  adId: PropTypes.string.isRequired,
  adPath: PropTypes.string.isRequired,
  adSizes: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ),
    ])
  ),
  adResponsiveSizesMap: PropTypes.arrayOf(
    PropTypes.shape({
      viewport: PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.arrayOf(PropTypes.number),
        ])
      ).isRequired,
      sizesMap: PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.arrayOf(PropTypes.number),
        ])
      ).isRequired,
    })
  ),
  showAdSlotOnBreakpoints: PropTypes.arrayOf(PropTypes.bool),
};

export default GooglePublisherTagLandscapeAdSlot;
